import { Input, Loader, TextInput } from "@mantine/core";
import { useDebouncedCallback } from "@mantine/hooks";
import { MagnifyingGlassIcon } from "@phosphor-icons/react";
import { ChangeEvent, useEffect, useState } from "react";

export function SearchInput({ searchValue, onSearchChange, delay = 300 }: { searchValue: string; onSearchChange: (value: string) => void; delay?: number }) {
  const [localValue, setLocalValue] = useState(searchValue);
  const [isSearching, setIsSearching] = useState(false);

  // Sincroniza o valor local com o prop quando ele muda externamente
  useEffect(() => {
    setLocalValue(searchValue);
  }, [searchValue]);

  const debouncedSearch = useDebouncedCallback((value: string) => {
    onSearchChange(value);
    setIsSearching(false); // Para o loading quando a busca é executada
  }, delay);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.currentTarget.value;
    setLocalValue(newValue); // Atualiza imediatamente para responsividade
    setIsSearching(true); // Inicia o loading
    debouncedSearch(newValue); // Chama a função debounced com o valor
  };

  const handleClear = () => {
    setLocalValue("");
    setIsSearching(false); // Para o loading ao limpar
    onSearchChange("");
  };

  return (
    <div className="sticky top-15 z-10 w-full bg-white/40 p-2 backdrop-blur-md">
      <TextInput
        label="Placa"
        placeholder="Digite a placa do veículo"
        description="Informe a placa do veículo"
        leftSection={isSearching ? <Loader size={16} /> : <MagnifyingGlassIcon weight="bold" />}
        rightSection={localValue ? <Input.ClearButton onClick={handleClear} /> : null}
        onChange={handleChange}
        value={localValue}
        variant="default"
        classNames={{
          label: "!mb-0"
        }}
        w="100%"
        required
      />
    </div>
  );
}
